export const LINKTREES_FETCH       = Symbol.for('linktree.list');
export const LINKTREE_FETCH        = Symbol.for('linktree.get');
export const LINKTREE_INSERT       = Symbol.for('linktree.insert');
export const LINKTREE_UPDATE       = Symbol.for('linktree.update');
export const LINKTREE_DELETE       = Symbol.for('linktree.delete');
export const LINKTREES_PAGINATION  = Symbol.for('linktree.pagination');
export const LINKTREES_ORDERBY     = Symbol.for('linktree.orderby');
export const LINKTREES_FILTER      = Symbol.for('linktree.filter');

export const LINKTREE_LINKS_FETCH  = Symbol.for('linktree.link.list');
export const LINKTREE_LINK_INSERT  = Symbol.for('linktree.link.insert');
export const LINKTREE_LINK_UPDATE  = Symbol.for('linktree.link.update');
export const LINKTREE_LINK_DELETE  = Symbol.for('linktree.link.delete');
